import type {
	CustomItem,
	DropImageType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropImage = (item: Item | CustomItem): item is DropImageType => {
	return !!(item && item.__typename === 'Drop_Image');
};
